import { render, staticRenderFns } from "./courseworkSetting.vue?vue&type=template&id=08a23e32&scoped=true&"
import script from "./courseworkSetting.vue?vue&type=script&lang=js&"
export * from "./courseworkSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseworkSetting.vue?vue&type=style&index=0&id=08a23e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a23e32",
  null
  
)

export default component.exports